var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Title Company"}},[_c('input-text',{staticClass:"flex-1",attrs:{"name":"title_company","value":_vm.closing.title_company,"label":"Company","placeholder":"Company","read_only":_vm.read_only}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }